import React from "react"
import PropTypes from "prop-types"
import { OutboundLink } from "gatsby-plugin-google-analytics"

import concerto from "../images/logos/concerto.svg"
import genesys from "../images/logos/genesys.svg"
import JLL from "../images/logos/jll.svg"
import TTEC from "../images/logos/ttec.svg"
import Wazoku from "../images/logos/wazoku.svg"
import IBM from "../images/logos/ibm.svg"
import Bytes from "../images/logos/bytes.png"
import Microsoft from "../images/logos/microsoft.png"
import HIDGlobal from "../images/logos/hidglobal.svg"
import AWS from "../images/logos/aws.svg"

const SponsorLogo = ({logo}) => {
  const style = {
    backgroundColor: `#ff9500`,
    borderRadius: `50%`
  }
  switch(logo) {
    case 'concerto':
      return <OutboundLink href="https://www.concerto.co.uk/" target="_blank"><img src={concerto} className="img-fluid" /></OutboundLink>
    case 'genesys':
      return <OutboundLink href="https://www.genesys.com/en-gb" target="_blank"><img src={genesys} className="img-fluid" /></OutboundLink>
    case 'jll':
      return <OutboundLink href="https://www.jll.co.uk" target="_blank"><img src={JLL} className="img-fluid" /></OutboundLink>
    case 'ttec':
      return <OutboundLink href="https://ttecdigital.com/" target="_blank"><img src={TTEC} className="img-fluid" /></OutboundLink>
    case 'wazoku':
      return <OutboundLink href="https://www.wazoku.com/" target="_blank"><img src={Wazoku} className="img-fluid" /></OutboundLink>
    case 'ibm':
      return <OutboundLink href="https://www.ibm.com/uk-en" target="_blank"><img src={IBM} className="img-fluid" /></OutboundLink>
    case 'bytes':
      return <OutboundLink href="https://www.bytes.co.uk/" target="_blank"><img src={Bytes} className="img-fluid" /></OutboundLink>
    case 'microsoft':
      return <img src={Microsoft} className="img-fluid" />
    case 'hidglobal':
      return <OutboundLink href="https://www.hidglobal.com/" target="_blank"><img src={ HIDGlobal } className="img-fluid" /></OutboundLink>
    case 'aws':
      return <OutboundLink href="https://aws.amazon.com/" target="_blank"><img src={ AWS } className="img-fluid" /></OutboundLink>
    default:
      return <div style={style}></div>
  }
}

SponsorLogo.propTypes = {
  logo: PropTypes.string
}

SponsorLogo.defaultProps = {
  logo: ``
}

export default SponsorLogo
